import type { Middleware } from 'redux';
import { enrichChartMogul } from '../services/trackingService';
import { RootState } from '../reducers';
import { createOrUpdateSubscription } from '../features/plan/thunk';

const chartMogulMiddleware: Middleware<{}, RootState> = ({ getState }) => (
  next
) => (action) => {
  const result = next(action);
  const { plan, settings } = getState();

  if (action.type === createOrUpdateSubscription.fulfilled.type) {
    const { marketing } = plan;
    const { intent } = marketing;

    // Track marketing intent
    if (intent) {
      enrichChartMogul([{ type: 'String', key: 'Intent', value: intent }]);
    }

    // Track AB test variants when package is created or updated
    const chevronBelowPriceVariant =
      settings.user.tags.feature_chevron_below_price;
    if (chevronBelowPriceVariant !== undefined) {
      enrichChartMogul([
        {
          type: 'String',
          key: 'feature_chevron_below_price',
          value: chevronBelowPriceVariant,
        },
      ]);
    }

    const hideUpgradeLeftColumnVariant =
      settings.user.tags.feature_hide_upgrade_left_column;
    if (hideUpgradeLeftColumnVariant !== undefined) {
      enrichChartMogul([
        {
          type: 'String',
          key: 'feature_hide_upgrade_left_column',
          value: hideUpgradeLeftColumnVariant,
        },
      ]);
    }
  }

  return result;
};

export default chartMogulMiddleware;
